import { render } from "./customer-service.vue?vue&type=template&id=1d506f4a&ts=true"
import script from "./customer-service.vue?vue&type=script&lang=ts"
export * from "./customer-service.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__